import React from 'react';

const OrderedList = ({ children }) => (
  <ol className="list-outside list-decimal leading-relaxed p-0 pl-12 my-3 md:my-6 lg:my-8">
    {children}
  </ol>
);

export default OrderedList;
